export const mutations = {
    SET_CONGREGACOES(state, congregacoes) {
        state.congregacoes = congregacoes;
    }
};